import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ProgressBar } from "@/components/Badges";
import { ChevronRight } from "lucide-react";

const fmt = (v) => `${Math.round(Number(v || 0) * 100)}%`;

export default function Regions() {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/regions").then((r) => setRegions(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto px-10 py-10 fade-in-up" data-testid="regions-page">
      <div className="mb-10">
        <div className="mono text-[10px] uppercase tracking-widest text-[color:var(--ink-2)] mb-2">
          Geographic Hierarchy
        </div>
        <h1 className="serif text-5xl tracking-tight leading-none">Regions</h1>
        <p className="text-sm text-[color:var(--ink-2)] mt-3 max-w-xl">
          Three primary regions coordinate translation across every country, cluster, and
          language project.
        </p>
      </div>

      {loading ? (
        <div className="mono text-xs text-[color:var(--ink-2)]">Loading…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {regions.map((r) => (
            <Link
              to={`/regions/${r.id}`}
              key={r.id}
              className="hairline bg-white p-8 hover:bg-[color:var(--surface-2)] transition-colors group"
              data-testid={`region-card-${r.name}`}
            >
              <div className="flex justify-between items-start mb-6">
                <div>
                  <div className="mono text-[10px] uppercase tracking-widest text-[color:var(--ink-2)] mb-2">
                    Region
                  </div>
                  <div className="serif text-4xl tracking-tight">{r.name}</div>
                </div>
                <ChevronRight
                  size={18}
                  strokeWidth={1.5}
                  className="text-[color:var(--ink-3)] group-hover:translate-x-0.5 transition-transform"
                />
              </div>

              <div className="grid grid-cols-3 gap-4 mb-6">
                <StatMini label="Countries" value={r.countries_count} />
                <StatMini label="Clusters" value={r.clusters_count} />
                <StatMini label="Projects" value={r.projects_count} />
              </div>

              <div className="mb-2 flex justify-between items-baseline">
                <span className="mono text-[10px] uppercase tracking-widest text-[color:var(--ink-2)]">
                  Avg Progress
                </span>
                <span className="mono text-sm">{fmt(r.avg_progress)}</span>
              </div>
              <ProgressBar value={r.avg_progress} />

              <div className="mt-4 flex gap-4 mono text-[10px] uppercase tracking-widest">
                <span className="text-[color:var(--on-track)]">● {r.on_track_count} On Track</span>
                <span className="text-[color:var(--behind)]">● {r.behind_count} Behind</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function StatMini({ label, value }) {
  return (
    <div>
      <div className="mono text-[9px] uppercase tracking-widest text-[color:var(--ink-2)]">{label}</div>
      <div className="serif text-2xl tracking-tight">{value}</div>
    </div>
  );
}
